var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9032_218976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.99816H2C1.73478 1.99816 1.48043 2.10352 1.29289 2.29105C1.10536 2.47859 1 2.73294 1 2.99816V9.99816C1 10.2634 1.10536 10.5177 1.29289 10.7053C1.48043 10.8928 1.73478 10.9982 2 10.9982H9C9.26522 10.9982 9.51957 10.8928 9.70711 10.7053C9.89464 10.5177 10 10.2634 10 9.99816V6.49816M9.25 1.24816C9.44891 1.04925 9.7187 0.9375 10 0.9375C10.2813 0.9375 10.5511 1.04925 10.75 1.24816C10.9489 1.44707 11.0607 1.71686 11.0607 1.99816C11.0607 2.27946 10.9489 2.54925 10.75 2.74816L6 7.49816L4 7.99816L4.5 5.99816L9.25 1.24816Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9032_218976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit__.c7986733409d374c7d13281e7340961a.svg";
export { ForwardRef as ReactComponent };